import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["formControlUse"];
import { memo } from 'react';
import useComponentMountMetric from '../metrics/useComponentMountMetric';
import { HighlySensitiveDataMaskedDisplay } from '../dataSensitivity/HighlySensitiveDataMaskedDisplay';
import { getDataAttributes } from '../utils/getDataAttributes';
import { jsx as _jsx } from "react/jsx-runtime";
const PropertyInputHighlySensitive = props => {
  const {
      formControlUse
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  useComponentMountMetric('PropertyInputHighlySensitive');
  return /*#__PURE__*/_jsx(HighlySensitiveDataMaskedDisplay, {
    dataAttributes: getDataAttributes(rest),
    formControlUse: formControlUse
  });
};
export default /*#__PURE__*/memo(PropertyInputHighlySensitive);